export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11415.c8cba30d.jpg";